import React from 'react';
import CounterCard from '../../../components/Molecules/Card/CounterCard/CounterCard';
import * as Constants from '../../../constants';
import NoDressing from '../../../containers/try2/Customization/try2Customization/cards/NoDressing';
import OtherDressing from '../../../containers/try2/Customization/try2Customization/cards/OtherDressing';
import styleClasses from '../../../containers/try2/try2.module.scss';
import { isItSubstituteGroupFromMultipleRequired, verifyStatus } from '../../../helpers/customizedItem/customizedItem.helper';
import { selectedIngredient } from '../../../helpers/helperMethods';
import { IItemsRequiredModifierGroups, IRequiredModifiersGroupsModifiers } from '../../../models/item.model';
import { INoDressingModifier } from '../../../models/try2Combo';
import { itemBuckets } from '../../../priceCalculation/buckets';
import { ICurrentModifier } from '../../../priceCalculation/priceCalculation';
import SelectCard from '../../Molecules/Card/SelectCard/SelectCard';

interface IRequiredModifiers {
  requiredModifiers: IRequiredModifiersGroupsModifiers[];
  selectedIngredients: IRequiredModifiersGroupsModifiers[];
  extendable_limit: number;
  min: number;
  isLimitExceed: (extendable_limit: number) => boolean;
  handleClick: (data: any, in_item: boolean) => void;
  showIngredientsModalHandler: () => void;
  requiredModifierGroup: IItemsRequiredModifierGroups;
  noDressingHandler: (modifier: INoDressingModifier, itemNo) => void;
  label: string;
  refScrollLeft?: any;
  showRedBorderAnimation?:boolean;
  dbId: string;
}

const Dreesing: React.FC<IRequiredModifiers> = (props) => {
  const { requiredModifiers, selectedIngredients, extendable_limit, min, isLimitExceed, handleClick, showIngredientsModalHandler, requiredModifierGroup, noDressingHandler, label, refScrollLeft, showRedBorderAnimation, dbId } = props
  let isOtherDreesingSelected: boolean = false;

  const requiredModifiersBucket = (function () {
    return itemBuckets.getSingleBucket({name:Constants.REQUIRED_MODIFIERS, fromItem:Constants.SINGLE_ITEM_SELECTED_SECTION});
  })();

  const checkModifierExistence = (additionalAdded:ICurrentModifier[], additionalRemoved:ICurrentModifier[], modifier) =>{
    let modifierExistence = additionalAdded.find(mod => mod.modifier_id === modifier.id);
    if(!modifierExistence){
      modifierExistence = additionalRemoved.find(mod => mod.modifier_id === modifier.id);
    }
    if(modifierExistence){
      return true;
    }else{
      return false
    }
  }
  const showModifier = (modifier:IRequiredModifiersGroupsModifiers, selected:any) => {
    const additionalAdded = requiredModifiersBucket?.additionalAdded?.modifiers;
    const additionalRemoved = requiredModifiersBucket?.additionalRemoved?.modifiers;
    const modifierExistence = checkModifierExistence(additionalAdded, additionalRemoved, modifier);
    if (!isShowOtherDreesingCard()) {
      if (modifier?.in_item || selected?.in_slide || modifierExistence) {
        return true;
      } else {
        return true
      }
    } else {
      if (modifier?.in_item || selected?.in_slide || modifierExistence) {
        return true;
      } else {
        return false
      }
    }
  };


  const isShowOtherDreesingCard = () => {
    let isTrue, isFalse = false
    if (requiredModifiers) {
      isTrue = requiredModifiers.every(modifier => modifier?.in_item);
      isFalse = requiredModifiers.every(modifier => !modifier?.in_item);
    }
    if (isTrue || isFalse) {
      return false
    } else {
      return true
    }
  }


  const selectedDreesings = (modifier) => {
    const selectedModifier = selectedIngredient(
      modifier,
      selectedIngredients
    );
    if (selectedModifier && !isOtherDreesingSelected && !modifier?.in_item) {
      isOtherDreesingSelected = true;
    }
    return selectedModifier
  }

  const isShowNoDressing = () => {
    if (!isShowOtherDreesingCard() && requiredModifierGroup?.min === 0) {
      return true;
    }
    if (
      requiredModifiersBucket?.noDressings?.find(
        (modGroup) => modGroup.id === requiredModifierGroup.id,
      )
    ) {
      return true;
    }
    return false;
  };

  // checking if mod group has noDressinng already added in bucket
  const getNoDressingForModifierGroup = () => {
    const requiredModifiersBucket = itemBuckets.getSingleBucket(
      {
        name: Constants.REQUIRED_MODIFIERS,
        fromItem: Constants.SINGLE_ITEM_SELECTED_SECTION
      }
    );
    return requiredModifiersBucket?.noDressings ? requiredModifiersBucket?.noDressings.find(
      (e) => e.id === requiredModifierGroup.id
    ) : null;
  }
  const noDressing = (function () {
    let noModifierGroupState = getNoDressingForModifierGroup();
    return noModifierGroupState && noModifierGroupState?.noDressing
  })();

  const decideCard = (modifier: IRequiredModifiersGroupsModifiers) => {
    let isCategorySelected = selectedIngredients.find(
      selected => selected.modifier_group_id === requiredModifierGroup.id
    )
    return isCategorySelected &&
      !isItSubstituteGroupFromMultipleRequired(requiredModifierGroup) && modifier?.max > 1
  }
  
  const autoSelectModifierCard = (modifier) => {
    return requiredModifiers?.length === 1 && modifier?.max === 1 && !dbId?.length; 
  }

  return (

    <div id="scroll_on_dressing_in_item_detail_page" key={`${requiredModifierGroup?.id}`} ref={refScrollLeft} className={`${styleClasses.items_inner_wrap} mb-3 d-flex items--inner-wrap ${styleClasses.dressing_items_scrollbar}`}>
      {requiredModifiers?.map(
        (modifier: IRequiredModifiersGroupsModifiers, index:number) => {
          // index+1 === requiredModifiers.length && scrollToLeft()
          const selectedModifier = selectedDreesings(modifier);
          return (
            showModifier(modifier, selectedModifier) && (
              decideCard(modifier) ? (
                  <CounterCard
                    id={modifier?.id}
                    key={modifier?.id}
                    brink_id={modifier?.brink_modifier_id}
                    image={`${Constants.REACT_APP_CLOUD_FRONT}${modifier?.image}`}
                    title={modifier.name}
                    price={modifier.price}
                    calories={modifier.calories}
                    max={modifier.max}
                    groupMin={min}
                    is_active={verifyStatus(modifier, Constants.MODIFIER_LOCATION)}
                    priceAlternateLabel={selectedModifier ? ' ' : ' '}
                    handleClick={(data) => {
                      handleClick(data, modifier?.in_item);
                    }}
                    count={selectedModifier?.quantity || 0}
                    from={Constants.TRY_2_COMBO}
                    additionalPrice={selectedModifier?.additionalPrice}
                    extendableLimit={isLimitExceed(
                      extendable_limit
                    )}
                    extendableLimitValue={extendable_limit}
                    showRedBorderAnimation={showRedBorderAnimation}
                  />
                  ) : (
                  <SelectCard
                    id={modifier?.id}
                    key={modifier?.id}
                    brink_id={modifier?.brink_modifier_id}
                    image={`${Constants.REACT_APP_CLOUD_FRONT}${modifier?.image}`}
                    title={modifier.name}
                    price={modifier.price}
                    calories={modifier.calories}
                    groupMin={min}
                    is_active={verifyStatus(modifier, Constants.MODIFIER_LOCATION)}
                    priceAlternateLabel={selectedModifier ? ' ' : ' '}
                    handleClick={(data) => {
                      handleClick(data, modifier?.in_item);
                    }}
                    selected={Boolean(selectedModifier)}
                    default_selected={modifier.is_selected}
                    modifierAdditionalPrice={selectedModifier?.additionalPrice}
                    extendableLimit={isLimitExceed(
                      extendable_limit
                    )}
                    extendableLimitValue={extendable_limit}
                    showRedBorderAnimation={showRedBorderAnimation}
                    shouldAutoSelect={autoSelectModifierCard(modifier)}
                    modifier_count={
                      modifier?.modifier_count
                    }
                    relatedModifierGroupId={modifier?.related_modifier_group}
                  />
              )
              )
          );
         
        }
      )}
      {isShowNoDressing() && (
        <div className={styleClasses.no_Dressing_Card}>
        <NoDressing
        label={requiredModifierGroup?.no_modifier_label}
         groupId={requiredModifierGroup?.id}
         noDressingHandler={noDressingHandler}
         isNoDressing={noDressing}
         itemNo={Constants.SINGLE_ITEM_SELECTED_SECTION.toString()}
         noDressingCardBorderRadius={styleClasses.no_Dressing_Card_Border_radius}
         showRedBorderAnimation={showRedBorderAnimation}
       />
        </div>
      )}
      {isShowOtherDreesingCard() && (
        <OtherDressing 
          groupMin={requiredModifierGroup.min} 
          otherDressingHandler={showIngredientsModalHandler} 
          selectCard={isOtherDreesingSelected} 
          isNoDressing={noDressing} 
          label={label} 
          showRedBorderAnimation={showRedBorderAnimation}
          modifierGroup={requiredModifiers}
        />
      )}
     
    </div>
  );
};

export default Dreesing;